import queryString from 'query-string';

const BASE_URL = '/api/application_categories/category_assignments';

class Api {
  getHeaders(headers) {
    return Object.assign({}, {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-api-authenticate': localStorage.getItem('userKey'),
    }, headers);
  }

  handleResponse = (response) => {
    if (response.ok) return response.json();
    return response.json().then((error) => {
      error.code = response.status;
      throw error;
    });
  }

  get = (path, params = {}, headers = {}) => (
    fetch(`${BASE_URL}${path}?${queryString.stringify(params, { arrayFormat: 'bracket' })}`, {
      headers: this.getHeaders(headers),
    }).then((r) => this.handleResponse(r))
  )

  post = (path, params = {}, headers = {}) => (
    fetch(`${BASE_URL}${path}`, {
      headers: this.getHeaders(headers),
      method: 'POST',
      body: JSON.stringify(params),
    }).then((r) => this.handleResponse(r))
  )

  put = (path, params = {}, headers = {}) => (
    fetch(`${BASE_URL}${path}`, {
      headers: this.getHeaders(headers),
      method: 'PUT',
      body: JSON.stringify(params),
    }).then((r) => this.handleResponse(r))
  )

  delete = (path, params = {}, headers = {}) => (
    fetch(`${BASE_URL}${path}`, {
      headers: this.getHeaders(headers),
      method: 'DELETE',
      body: JSON.stringify(params),
    }).then((r) => this.handleResponse(r))
  )

  getCategories = (entityId) => this.get(`/${entityId}`);

  updateCategories = (entityId, params) => this.put(`/${entityId}`, params);

  createDefaultCategories = (entityId) => this.post(`/${entityId}/create_defaults`);

  removeCategories = (entityId) => this.delete(`/${entityId}`);
}

export default new Api();
